import React, { Component } from 'react';
import { Footer } from '@emorg-prd/react-standard';
import './index.css';
export default class FooterArea extends Component {
  render() {
    return <Footer variant='Horizontal links'>E&PS Data Analytics and Technology</Footer>;
  }
}
